import * as applicationSubmitActions from '../actions/applicationSubmitActions';
const initialState = {};
export default (state = initialState, action) => {
  //NOSONAR
  if (action.type === applicationSubmitActions.APPLICATION_SUBMIT_RESPONSE) {
    return {
      ...state,
      responseData: {
        ...action.data,
      },
    };
  }
  return state;
};
